<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateUserManage.queryCondition') }}</span>
      </div>
      <el-form :inline="true" class="demo-form-inline text-left">
        <el-form-item>
          <el-input 
            v-model="affiliateUserManageInfo.conditions.userName" 
            :placeholder="$t('affiliateUserManage.pleaseInputAffiliateUser')"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            size="small"
            @click="_queryAffiliateUserMethod"
          >
            {{ $t('affiliateUserManage.query') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px;">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateUserManage.affiliateUser') }}</span>
      </div>
      <el-table
        :data="affiliateUserManageInfo.affiliateUsers"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          prop="auId"
          :label="$t('affiliateUserManage.affiliateUserId')"
          align="center"
        />
        <el-table-column
          prop="ruleId"
          :label="$t('affiliateUserManage.ruleId')"
          align="center"
        />
        <el-table-column
          prop="userId"
          :label="$t('affiliateUserManage.relatedUserId')"
          align="center"
        />
        <el-table-column
          prop="userName"
          :label="$t('affiliateUserManage.affiliateUser')"
          align="center"
        />
        <el-table-column
          prop="parentId"
          :label="$t('affiliateUserManage.parentAffiliateUserId')"
          align="center"
        />
        <el-table-column
          prop="parentUserName"
          :label="$t('affiliateUserManage.parentAffiliateUser')"
          align="center"
        />
        <el-table-column
          prop="level"
          :label="$t('affiliateUserManage.affiliateLevel')"
          align="center"
        >
          <template #default="{row}">
            {{ _level(row.level) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          :label="$t('affiliateUserManage.status')"
          align="center"
        >
          <template #default="{row}">
            {{ _auditState(row.state) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="totalCommission"
          :label="$t('affiliateUserManage.totalCommission')"
          align="center"
        />
        <el-table-column
          prop="availableCommission"
          :label="$t('affiliateUserManage.availableCommission')"
          align="center"
        />
        <el-table-column
          prop="withdrawnCommission"
          :label="$t('affiliateUserManage.withdrawnCommission')"
          align="center"
        />
        <el-table-column
          prop="teamCount"
          :label="$t('affiliateUserManage.teamCount')"
          align="center"
        />
        <el-table-column
          prop="auditReason"
          :label="$t('affiliateUserManage.auditReason')"
          align="center"
        />
        <el-table-column
          prop="createTime"
          :label="$t('affiliateUserManage.createTime')"
          align="center"
        />
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="affiliateUserManageInfo.conditions.page"
        :page-size="affiliateUserManageInfo.conditions.row"
        layout="total, prev, pager, next"
        :total="affiliateUserManageInfo.total"
        style="margin-top: 20px; text-align: right;"
      />
    </el-card>

    <delete-affiliate-user ref="deleteAffiliateUserRef" @refresh="_listAffiliateUsers" />
  </div>
</template>

<script>
import { listAffiliateUser } from '@/api/affiliate/affiliateUserApi'
import DeleteAffiliateUser from '@/components/affiliate/deleteAffiliateUser/deleteAffiliateUser.vue'

export default {
  name: 'AffiliateUserManage',
  components: {
    DeleteAffiliateUser
  },
  data() {
    return {
      loading: false,
      affiliateUserManageInfo: {
        affiliateUsers: [],
        total: 0,
        records: 1,
        conditions: {
          userName: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAffiliateUsers()
  },
  methods: {
    async _listAffiliateUsers(page = 1, rows = 10) {
      this.loading = true
      this.affiliateUserManageInfo.conditions.page = page
      this.affiliateUserManageInfo.conditions.row = rows
      
      try {
        const res = await listAffiliateUser(this.affiliateUserManageInfo.conditions)
        this.affiliateUserManageInfo.total = res.total
        this.affiliateUserManageInfo.records = res.records
        this.affiliateUserManageInfo.affiliateUsers = res.data
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    _queryAffiliateUserMethod() {
      this._listAffiliateUsers()
    },
    handleCurrentChange(val) {
      this._listAffiliateUsers(val, this.affiliateUserManageInfo.conditions.row)
    },
    _openDeleteAffiliateUserModel(affiliateUser) {
      this.$refs.deleteAffiliateUserRef.open(affiliateUser)
    },
    _level(state) {
      if (state == "1") return this.$t('affiliateUserManage.level1')
      if (state == "2") return this.$t('affiliateUserManage.level2')
      return state
    },
    _auditState(state) {
      if (state == "0") return this.$t('affiliateUserManage.pendingReview')
      if (state == "1") return this.$t('affiliateUserManage.approved')
      if (state == "2") return this.$t('affiliateUserManage.rejected')
      return state
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 样式，无需自定义样式 */
</style>